export default "__VITE_ASSET__DViYpfXI__"